import { ILanguage } from '../types/ILanguage';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetLanguagesParams {
}

export interface IGetLanguagesResult {
  languages: ILanguage[];
}

export class GetLanguagesRequest extends Request<IGetLanguagesParams, IGetLanguagesResult> {
  constructor(params: IGetLanguagesParams = {}) {
    super('getLanguages', params);
  }
}
